module.exports = __webpack_public_path__ + "static/media/ssec.636b3d42.png";